import importTranslations from "../components/import/_langs/en-US";
import mainTranslations from "../modules/main/_langs/en-US";
import settingsTranslations from "../modules/settings/_langs/en-US";

export default {
  import: importTranslations,
  main: mainTranslations,
  settings: settingsTranslations,
};
